export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dadata-city-autocomplete.vue?vue&type=template&id=5dd54a23&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/dadata-autocomplete/dadata-city-autocomplete.vue?vue&type=template&id=5dd54a23&
// module id = 982
// module chunks = 0